import {sendError} from '../../app/errorDisplayer';
import config from '../../../common/config';

export default function getImage(url, customNotFoundTest) {
	return new Promise((resolve, reject) => {
		let xhr = new XMLHttpRequest();

		let changedUrl = url + (url.includes('?') ? '&' : '?') + 'timestamp=' + Date.now();

		xhr.open("GET", changedUrl, true);

		// Ask for the result as an ArrayBuffer.
		xhr.responseType = "arraybuffer";

		xhr.onload = () => {
			// if (xhr.status === 404) {
			if (xhr.status >= 400) {
				reject();
			}
			else if (xhr.status === 200) {
				if (customNotFoundTest && customNotFoundTest(xhr)) {
					reject();
				}
				else {
					try {
						let imageBlob = new Blob([new window.Uint8Array(xhr.response)]);
						let imageUrl = URL.createObjectURL(imageBlob);

						resolve(imageUrl);
					}
					catch (e) {
						reject();
					}
				}
			}
		};

		xhr.onloadend = () => {
			if (xhr.status === 404) {
				reject();
			}
		};

		xhr.onerror = (e) => {
			sendError(e);
			reject();
		};

		xhr.send();
	});
}

export function getImageByImgEl(service, id) {
	return new Promise((resolve, reject) => {
		fetch((config.GLOBAL_API_URL || config.apiHost) + '/public/logobox?service=' + encodeURIComponent(service) + '&id=' + encodeURIComponent(id), {
			headers: {}
		}).then((response) => {
			response.json().then(body => {
				if (body.status === 'success') {
					resolve(body.result);
				}
				else {
					reject();
				}
			}).catch(() => {
				reject();
			});
		}).catch((e) => {
			reject();
		});
	});
}
